module.exports = __webpack_public_path__ + "static/media/Position.07a5bb19.logo";